<template>
  <div class="plan-activity-panel activity-content">
    <slot v-if="showCompose" name="compose" />

    <div :class="listContainerClass">
      <template v-if="activities.length > 0">
        <ActivitySection
          :activities="activities"
          :activity-read-only="activityReadOnly"
          :feedback-read-only="feedbackReadOnly"
          :show-activity-edit-delete="showActivityEditDelete"
          :show-read-status="effectiveShowReadStatus"
          :editor-resizable="editorResizable"
          @activity-updated="emit('activity-updated', $event)"
        />
        <slot name="list-footer" />
      </template>

      <slot v-else name="empty">
        <div class="activity-empty">{{ t('task.common.noRegisteredActivities') }}</div>
      </slot>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import ActivitySection from '~/components/domain/Activity/ActivitySection.vue';

const { t } = useI18n();

const props = defineProps({
  activities: {
    type: Array,
    default: () => [],
  },
  activityReadOnly: {
    type: Boolean,
    default: false,
  },
  feedbackReadOnly: {
    type: Boolean,
    default: false,
  },
  /** activityReadOnly일 때 수정/삭제 버튼 표시 (기본 false = 숨김) */
  showActivityEditDelete: {
    type: Boolean,
    default: false,
  },
  showReadStatus: {
    type: Boolean,
    default: true,
  },
  planType: {
    type: String,
    default: '',
  },
  showCompose: {
    type: Boolean,
    default: false,
  },
  /** 활동/피드백 에디터를 드래그 리사이즈 모드로 표시 (업무/협업 화면 전용, 기본값 false) */
  editorResizable: {
    type: Boolean,
    default: false,
  },
  listContainerClass: {
    type: String,
    default: 'activity-scroll-container',
  },
});

/** 인사평가 등 activity+feedback 모두 read-only 이면 읽음/NEW 배지 숨김 */
const effectiveShowReadStatus = computed(
  () => props.showReadStatus && !(props.activityReadOnly && props.feedbackReadOnly),
);

const emit = defineEmits(['activity-updated']);
</script>

<style scoped lang="scss">
.plan-activity-panel {
  :deep(.activity-section) {
    margin-top: 0;
  }
}

.activity-empty {
  padding: 24px 0;
  text-align: center;
  color: #6d7882;
  font-size: 14px;
}
</style>
